<template>
  <div>
    <form
      autocomplete="off"
      class="m-container-primary"
      @submit.prevent="createProductoCuponDescuento"
    >
      <div class="row">
        <div class="column column-8">
          <AtomInputPrimary
            v-model="productoCuponDescuento.codigo"
            :input-error="$v.productoCuponDescuento.codigo.$error || nameInUse"
            :label="$t('mEditionProductDiscountCodesCreate.inputs.codigo.label')"
            :message-error="messageErrorCodigo"
            name="codigo"
            :placeholder="$t('mEditionProductDiscountCodesCreate.inputs.codigo.placeholder')"
            type="text"
            @blur="$v.productoCuponDescuento.codigo.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div
          v-if="false"
          class="column column-4">
          <AtomSelectPrimary
            v-model.number="productoCuponDescuento.tipo_descuento"
            :elements="cuponDescuentoTipos"
            key-field="id"
            :label="$t('mEditionProductDiscountCodesCreate.inputs.tipo_descuento.label')"
            name="tipo_descuento"
            text-field="texto"
          />
        </div>

        <div
          v-if="productoCuponDescuento.tipo_descuento == 0"
          key="descuentoPorcent"
          class="column column-8"
        >
          <AtomInputPrimary
            v-model="productoCuponDescuento.monto_descuento_0"
            :input-error="$v.productoCuponDescuento.monto_descuento_0.$error"
            :label="$t('mEditionProductDiscountCodesCreate.inputs.monto_descuento_porcent.label')"
            :message-error="messageErrorMontoDescuento0"
            name="monto_descuento_0"
            :placeholder="$t('mEditionProductDiscountCodesCreate.inputs.monto_descuento_porcent.placeholder')"
            type="text"
            @blur="$v.productoCuponDescuento.monto_descuento_0.$touch()"
          />
        </div>

        <div
          v-else
          key="descuentoFinal"
          class="column column-4"
        >
          <AtomInputPrimary
            v-model="productoCuponDescuento.monto_descuento_1"
            :input-error="$v.productoCuponDescuento.monto_descuento_1.$error"
            :label="$t('mEditionProductDiscountCodesCreate.inputs.monto_descuento_final.label')"
            :message-error="messageErrorMontoDescuento1"
            name="monto_descuento_1"
            :placeholder="$t('mEditionProductDiscountCodesCreate.inputs.monto_descuento_final.placeholder')"
            type="text"
            @blur="$v.productoCuponDescuento.monto_descuento_1.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-4">
          <AtomDatePicker
            v-model="productoCuponDescuento.fecha_inicio"
            :disabled-dates="disabledDatesStart"
            input-class="width-100-pr"
            :label="$t('mEditionProductDiscountCodesCreate.inputs.fecha_inicio.label')"
            :message="$t('mEditionProductDiscountCodesCreate.inputs.fecha_inicio.message')"
            name="fecha_inicio"
          />
        </div>

        <div class="column column-4">
          <AtomDatePicker
            v-model="productoCuponDescuento.fecha_fin"
            :disabled="productoCuponDescuento.fecha_inicio === null || productoCuponDescuento.fecha_inicio === ''"
            :disabled-dates="disabledDatesEnd"
            input-class="width-100-pr"
            :label="$t('mEditionProductDiscountCodesCreate.inputs.fecha_fin.label')"
            :message="$t('mEditionProductDiscountCodesCreate.inputs.fecha_fin.message')"
            name="fecha_fin"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-8">
          <AtomButtonPrimary :button-primary="buttonPrimary"/>
          <AtomButtonSecondary
            v-if="false"
            :button-secondary="buttonSecondary.reset"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { decimal, maxLength, minLength, maxValue, minValue, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductDiscountCodesCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductDiscountCodesCreate.buttonPrimary'),
        class: 'margin-right-medium margin-top-large',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      cuponDescuentoTipos: [
        {
          id: 0,
          texto: 'Aplicar descuento sobre precio final'
        },

        {
          id: 1,
          texto: 'Utilizar descuento como precio final'
        }
      ],

      disabledDatesEnd: {
        to: ''
      },

      disabledDatesStart: {
        to: ''
      },

      nameInUse: false,

      productoCuponDescuento: {
        codigo: '',
        fecha_fin: null,
        fecha_inicio: null,
        monto_descuento: '',
        monto_descuento_0: '',
        monto_descuento_1: '',
        tipo_descuento: 0
      }
    }
  },

  validations: {
    productoCuponDescuento: {
      codigo: {
        maxLength: maxLength(20),
        minLength: minLength(4),
        required
      },

      monto_descuento_0: {
        decimal,
        maxValue: maxValue(100),
        minValue: minValue(0.01),
        required
      },

      monto_descuento_1: {
        decimal,
        minValue: minValue(0.01),
        required
      }
    }
  },

  computed: {
    messageErrorCodigo () {
      // TODO: colocar mensaje de error de nombre en uso en archivo de traducción
      if (this.nameInUse) {
        return 'El nombre del código de descuento ya está en uso.'
      } else {
        return this.$validation.getValidationMessage('mEditionProductDiscountCodesCreate', this.$v.productoCuponDescuento.codigo, 'codigo')
      }
    },

    messageErrorMontoDescuento0 () {
      return this.$validation.getValidationMessage('mEditionProductDiscountCodesCreate', this.$v.productoCuponDescuento.monto_descuento_0, 'monto_descuento_0')
    },

    messageErrorMontoDescuento1 () {
      return this.$validation.getValidationMessage('mEditionProductDiscountCodesCreate', this.$v.productoCuponDescuento.monto_descuento_1, 'monto_descuento_1')
    }
  },

  watch: {
    'productoCuponDescuento.fecha_inicio' () {
      if (this.productoCuponDescuento.fecha_inicio === null || this.productoCuponDescuento.fecha_inicio === '' ||
        this.$moment(this.productoCuponDescuento.fecha_inicio).isAfter(this.productoCuponDescuento.fecha_fin)) {
        this.productoCuponDescuento.fecha_fin = null
      }

      this.disabledDatesEnd = {
        to: this.productoCuponDescuento.fecha_inicio
      }
    }
  },

  mounted () {
    this.disabledDatesStart = {
      to: this.$moment().subtract(1, 'days')
    }
  },

  methods: {
    createProductoCuponDescuento () {
      this.validarMontoDescuento()
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        if (this.productoCuponDescuento.fecha_inicio === this.$moment(new Date()).format('YYYY-MM-DD')) {
          if (this.productoCuponDescuento.fecha_fin === this.$moment(new Date()).format('YYYY-MM-DD')) {
            this.productoCuponDescuento.fecha_fin = this.$moment.parseZone(new Date()).utcOffset(120).format('YYYY-MM-DD')
            this.productoCuponDescuento.fecha_inicio = this.$moment.parseZone(new Date()).utcOffset(120).format('YYYY-MM-DD')
          } else {
            this.productoCuponDescuento.fecha_inicio = this.$moment.parseZone(new Date()).utcOffset(120).format('YYYY-MM-DD')
          }
        }
        this.$services.create('producto', 'createProductoCuponDescuento', this.productoCuponDescuento, [this.$route.params.id])
          .then(response => {
            this.$alerts.pushAlert('mEditionProductDiscountCodesCreate', 'createProductoCuponDescuento', 'success')
            this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.discountCodes.subject')}`)
            this.buttonPrimary.sending = false
            this.resetMontoDescuento()
          })
          .catch(error => {
            console.log(error)
            console.log(this.nameInUse)
            this.nameInUse = error.response.data.error.message === 'El Código para el cupón ya está en uso'
            console.log(this.nameInUse)
            this.$alerts.pushAlert('mEditionProductDiscountCodesCreate', 'createProductoCuponDescuento', 'error', 'a-alert-danger')
            this.resetMontoDescuento()
            this.buttonPrimary.sending = false
          })
      } else {
        this.resetMontoDescuento()
      }
    },

    resetMontoDescuento () {
      if (this.productoCuponDescuento.tipo_descuento === 0) {
        this.productoCuponDescuento.monto_descuento_1 = ''
      } else {
        this.productoCuponDescuento.monto_descuento_0 = ''
      }
    },

    validarMontoDescuento () {
      if (this.productoCuponDescuento.tipo_descuento === 0) {
        this.productoCuponDescuento.monto_descuento = this.productoCuponDescuento.monto_descuento_0
        this.productoCuponDescuento.monto_descuento_1 = 0.01
      } else {
        this.productoCuponDescuento.monto_descuento = this.productoCuponDescuento.monto_descuento_1
        this.productoCuponDescuento.monto_descuento_0 = 0.01
      }
    }
  }
}
</script>
